<template>
  <v-app>
    <v-app-bar app color="#ffffff" height="70">
      <v-toolbar-title @click="$vuetify.goTo('#hero')">
        <div class="font-weight-bold" text  height="35">
            <span> {{ app_details.name[lang] }}</span>
        </div>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        text
        small
        class="grey--text text--darken-1"
        @click="$router.push('/')"
        >
        <v-icon>mdi-arrow-left</v-icon>
        {{ status.back[lang] }}
      </v-btn
      >
    </v-app-bar>

    <v-content>
      <div class="pa-10">
        <ol class="custom-list filled-disc">
          <li>
            <h2 class="pt-3">NOM, SIÈGE ET DURÉE</h2>
            <h3 class="pt-5">ART. 1 NOM, SIÈGE ET DURÉE</h3>
            <ol>
              <li class="pb-1">Sous le nom de <b>"Human Time Initiatives ou HTI"</b> (human-time.org) est créée. Une
                association à but non lucratif au sens des articles 60 et suivants du Code civil
                suisse 2 (ci-après : CC) qui est régie par les présents Statuts et subsidiairement par
                les dispositions du CC.</li>
              <li class="pb-1">Son siège est à <b>Eysins VD</b></li>
              <li class="pb-1">Sa durée est <b>indéterminée</b></li>
            </ol>

            <h3 class="pt-5">ART. 2 OBJET</h3>
            <p style="font-style: italic;">
              Dans notre nouveau monde où nous semblons mesurer chaque minute, mesurons-nous
              réellement le temps que nous consacrons à des choses qui contribuent véritablement à la
              création d'un monde mental et physique durable ? L'objectif principal de l'initiative HTI est de
              mesurer ces événements temporels implicites grâce aux étapes suivantes ;
            </p>

            <p style="font-size: 19px;">L’association <b>HTI</b> a pour objet :</p>
            <ol>
              <li class="pb-1"><b>Gestion efficace du temps :</b> Fournir des outils innovants, tels qu'un pointeur de
                gestion du temps, pour aider les équipes en Suisse et en mission à optimiser leur
                emploi du temps, améliorer leur productivité dans l'ensemble de la société et
                assurer un suivi rigoureux des activités.</li>
              <li class="pb-1"><b>Soutien à la gouvernance :</b> Fournir des ressources, des formations et des outils
                pour améliorer la gouvernance des ONG et associations, favoriser une gestion
                transparente et renforcer les capacités de décision des dirigeants.</li>
              <li class="pb-1"><b>Suivi et évaluation des projets :</b> Accompagner les ONG et associations dans le
                suivi et l’évaluation de leurs projets pour garantir la qualité, l’efficacité et l'impact
                des actions menées, avec des outils d’analyse et des indicateurs de performance
                adaptés.</li>
              <li class="pb-1"><b>Innovation et digitalisation :</b> Promouvoir l'innovation et la digitalisation des
                pratiques des ONG et associations, en facilitant l’accès à des technologies
                adaptées et en offrant des ateliers sur l’intégration des outils numériques dans leurs
                processus.</li>
              <li class="pb-1"><b>Collaboration et réseautage :</b> Créer un réseau de collaboration entre ONG et
                associations pour favoriser l’échange de bonnes pratiques, le partage de ressources
                et la création de projets communs dans un esprit de solidarité et d'entraide.</li>
              <li class="pb-1"><b>Promotion de la durabilité :</b> Encourager les ONG et associations à adopter des
                pratiques durables dans leurs activités et projets, en proposant des formations et
                des ressources sur la gestion écoresponsable et les pratiques respectueuses de
                l’environnement.</li>
            </ol>

            <h3 class="pt-5">ART. 3 MOYENS D’ACTION</h3>
            <p>Pour la réalisation de son objet, l’association a pour moyen principal d’action :</p>
            <p>La formation, l’administration, la gestion, la production, l’insertion, l’information, la
              représentation, l’organisation et la diffusion dans tous les domaines de compétence
              pour le développement du projet.</p>
          </li>
          <li>
            <h2 class="pt-3">ORGANISATION</h2>
            <h3 class="pt-5">ART. 4 ORGANES DE L’ASSOCIATION</h3>
            <p>Les organes de l’Association sont :</p>
            <ul>
              <li>L’Assemblée générale ;</li>
              <li>Le Comité ;</li>
              <li class="pb-1">L’Organe de contrôle des comptes.</li>
            </ul>

            <h3 class="pt-5">ART. 5 RESSOURCES</h3>
            <p>Les ressources de l’Association sont constituées par les cotisations ordinaires ou
              extraordinaires de ses membres, des dons, ou legs, par des produits des activités de
              l’Association et, le cas échéant, par des subventions des pouvoirs publics.</p>
            <p>L’exercice social commence le 1er janvier et se termine le 31 décembre de chaque
              année.</p>
            <p>Ses engagements sont garantis par ses biens, à l’exclusion de toute responsabilité
              personnelle de ses membres.</p>
          </li>
          <li>
            <h2 class="pt-3">MEMBRES</h2>
            <h3 class="pt-5">ART. 6 MEMBRES</h3>
            <p>Peuvent être membres toutes les personnes ou organismes intéressés à la réalisation
              des objectifs fixés par l’art. 2.</p>

            <h3 class="pt-2">ART. 7 ADHÉSION</h3>
            <p>Les demandes d’admission sont adressées au Comité. Le Comité admet les nouveaux
              membres et en informe l’Assemblée générale.</p>

            <h3 class="pt-2">ART. 8 FIN DE L’ADHÉSION</h3>
            <p>La qualité de membre se perd :</p>
            <ul>
              <li>Par la démission. Dans tous les cas la cotisation de l’année reste due.</li>
              <li>Le non-paiement répété des cotisations entraîne également l'exclusion.
                L’exclusion est du ressort du Comité. La personne concernée peut recourir contre
                cette décision devant l’Assemblée générale.</li>
              <li class="pb-1">L’organisation se permet d’exclure tout membre sans indication de motif.</li>
            </ul>
          </li>
          <li>
            <h2 class="pt-5">ASSEMBLÉE GÉNÉRALE</h2>
            <h3 class="pt-5">ART. 9 ASSEMBLÉ GÉNÉRALE</h3>
            <p>L’Assemblée générale est le pouvoir suprême de l’Association. Elle comprend tous les
              membres de celle-ci.</p>

            <h3 class="pt-2">ART. 10 COMPÉTENCES</h3>
            <p>Les compétences de l’Assemblée générale sont les suivantes, elle :</p>
            <ul>
              <li>Adopte l’ordre du jour de l’assemblée et approuve le procès-verbal de la dernière
                assemblée.</li>
              <li>Prend connaissance des rapports, des comptes de l’exercice et du budget et vote
                leur approbation.</li>
              <li>Donne décharge de leur mandat au Comité et à l’Organe de contrôle des comptes.</li>
              <li>Nomme les membres du Comité et désigne un Organe de contrôle des comptes.</li>
              <li>Adopte et modifie les statuts.</li>
              <li>Entend et traite les recours d’exclusion.</li>
              <li>Fixe-le ou les montants de cotisation annuelle des membres.</li>
              <li>Prend position sur les autres projets portés à l’ordre du jour.</li>
              <li class="pb-5">Élit les membres du comité</li>
            </ul>
            <p>L’Assemblée générale peut saisir ou être saisie de tout objet qu’elle n’a pas confié à
              un autre organe.</p>

            <h3 class="pt-2">ART. 11 RÉUNIONS</h3>
            <p>L’Assemblée générale se réunit au moins une fois par an sur convocation du Comité.</p>
            <p>Le Comité peut convoquer des assemblées générales extraordinaires aussi souvent
              que le besoin s'en fait sentir. L’Assemblée générale extraordinaire se réunit également
              à la demande d’au moins un cinquième des membres de l’Association.</p>

            <h3 class="pt-2">ART. 12 CONVOCATION</h3>
            <p>Les assemblées sont convoquées au moins 10 jours calendaires à l’avance par le
              Comité. La convocation est adressée par courrier écrit ou électronique et comprend
              l’ordre du jour de l’assemblée.</p>

            <h3 class="pt-2">ART. 13 ORDRE DU JOUR</h3>
            <p>Le Comité est tenu de porter à l’ordre du jour de l’Assemblée générale (ordinaire ou
              extraordinaire) toute proposition d’un membre présentée par courrier postal ou
              électronique au moins 20 jours calendaires à l’avance.</p>

            <h3 class="pt-2">ART. 14 ORGANISATION</h3>
            <p>L’assemblée est présidée par la Présidente ou le Président de l’association ou par un
              autre membre proposé par le Comité.</p>

            <p>Là où le Secrétaire de l’Association ou un autre membre du comité tient le procès-
              verbal de l’Assemblée ; il le signe avec la personne ayant présidée l’assemblée.</p>

            <h3 class="pt-2">ART. 15 DÉCISIONS ET DROITS DE VOTE</h3>
            <p>Les décisions de l’Assemblée générale sont prises à la majorité simple des voix
              exprimées, sans tenir compte des abstentions et d’éventuels bulletins nuls. En cas
              d’égalité des voix, celle du président de l’assemblée est prépondérante.</p>
            <p>Les décisions relatives à la modification des statuts ne peuvent être prises qu’à la
              majorité des 2/3 des membres présents et représentés.</p>

            <h3 class="pt-2">ART. 16 MODE</h3>
            <p>Les votations ont lieu à main levée. À la demande de 5 membres au moins, elles
              auront lieu au scrutin secret. Le vote par procuration est autorisé.</p>
          </li>

          <li>
            <h2 class="pt-3">COMITÉ</h2>
            <h3 class="pt-5">ART. 17 COMITÉ</h3>
            <p>Le Comité exécute et applique les décisions de l’Assemblée générale. Il conduit
              l’Association et prend toutes les mesures utiles pour que le but fixé soit atteint. Le
              Comité statue sur tous les points qui ne sont pas expressément réservés à l’Assemblée
              générale.</p>

            <h3 class="pt-2">ART. 18 COMPOSITION</h3>
            <p>Le Comité se compose au minimum de deux membres, nommés pour deux ans par
              l’Assemblée générale et rééligibles.</p>

            <h3 class="pt-2">ART. 19 RÉVOCATION ET DÉMISSION</h3>
            <p>En cas de vacances en cours de mandat, le Comité peut se compléter par cooptation
              jusqu’à la prochaine assemblée générale.</p>

            <h3 class="pt-2">ART. 20 RÉMUNÉRATION</h3>
            <p>Les membres du Comité de l'association travaillent de manière bénévole, sous réserve
              du remboursement de leurs frais effectifs.</p>

            <h3 class="pt-2">ART. 21 REPRÉSENTATION ET SIGNATURES</h3>
            <p>L’Association est valablement engagée par la signature collective de deux membres du
              Comité dont le Président.</p>

            <h3 class="pt-2">ART. 22 COMPÉTENCES</h3>
            <p>Le Comité a la charge :</p>
            <ul>
              <li>De prendre les mesures utiles pour atteindre les objectifs visés ;</li>
              <li>De convoquer les assemblées générales ordinaires et extraordinaires ;</li>
              <li>De prendre les décisions relatives à l’admission et l'éventuelle exclusion des
                membres ;</li>
              <li>De veiller à l’application des statuts, de rédiger les règlements et d’administrer les
                biens de l’Association.</li>
              <li class="pb-1">De tenir les comptes de l’Association.</li>
            </ul>

            <h3 class="pt-5">ART. 23 DÉLÉGATION</h3>
            <p>Le Comité engage (licencie) les collaboratrices et collaborateurs salariés et bénévoles
              de l’Association. Il peut confier à toute personne de l’Association ou extérieure à
              celle-ci un mandat limité dans le temps.</p>
          </li> 
          <li>
            <h2 class="pt-3">ORGANE DE CONTRÔLE</h2>
            <h3 class="pt-5">ART. 24 ORGANE DE CONTRÔLE</h3>
            <p>L’organe de contrôle des comptes vérifie la gestion financière de l’Association et
              présente un rapport à l’Assemblée générale. Il est désigné par l’Assemblée générale,
              en dehors des membres du comité.</p>
          </li>
          <li>
            <h2 class="pt-3">DISSOLUTION</h2>
            <h3 class="pt-5">ART. 25 DISSOLUTION</h3>
            <p>La dissolution de l’Association est décidée par l’Assemblée générale à la majorité des
              deux tiers des membres présents et représentés. Elle doit être mentionnée dans la
              convocation à cette assemblée. L’actif éventuel restant sera remis à une institution
              suisse exonérée d'impôt en raison de son but d'utilité publique ou de service
              publique.</p>
            <p>Les présents statuts ont été adoptés par l'assemblée constitutive du 20.01.2025 à
              Lausanne.</p>
          </li>
        </ol>

      </div>

    </v-content>

    <v-footer class="justify-center" color="#ffffff" height="50" elevation="5">
      <div
        class="subtitle-2 font-weight-bold grey--text text--darken-2 text-center"
      >
        {{ misc.copyright[lang] }} &copy; {{ new Date().getFullYear() }}
        {{ app_details.name[lang] }}
      </div>
    </v-footer>
  </v-app>
</template>

<script>
import translations from "@/translations/home";
export default {
  name: "home",
  components: {},
  mixins: [translations],
  data() {
    return {
      alert: false,
      alertText: "",
      snackbar: false,
      timeout: 1500,
      lang: "fr",
      showImages: false,
      showBackground: [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
      ]
    };
  },
  methods: {
  }
};
</script>
<style scoped>
  .v-main .v-content {
    padding: 0px 0px 0px !important;
  }
  .v-application {
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
  }
  .v-application .subtitle-1 {
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
  }
  .v-application .headline {
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
  }
  .v-application .body-1 {
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
  }
  .v-application .subtitle-2 {
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
  }
  .v-application .title {
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
  }

  .v-application .title-big {
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
    font-size: 1.5rem !important;
  }
  .v-application .display-1 {
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
    font-size: 1.8rem !important;
  }
  .v-application .display-2 {
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
  }
  .v-application .display-1a {
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
    font-size: 1.5rem !important;
    font-weight: normal;
  }
  .v-application .display-2a {
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
    font-size: 2rem !important;
    font-weight: normal;
  }
  .v-application .display-3 {
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
  }
  .v-application .display-4 {
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
  }
  .v-text-field {
    height: 50px;
  }
  .v-text-field.v-textarea {
    height: 163px;
  }
  .bg-img {
    background-image: url("../assets/teclinker-bg-scaled.jpg");
  }
  .bottom-pos {
    margin-top: 35%;
  }
  .no-padding {
    padding: 0px !important;
  }
  .center {
    margin: auto;
  }

  .elevate-paper {
    box-shadow: 1px 1px 1px 0px rgba(0, 0, 0, 0.2),
      2px 2px 2px 0px rgba(0, 0, 0, 0.14), 3px 3px 3px 0px rgba(0, 0, 0, 0.12) !important;
  }

  .v-card--reveal {
    bottom: 0;
    left: 0;
    opacity: 1 !important;
    position: absolute;
    width: 100%;
  }

  .v-card--reveal-how {
    top: 0;
    left: 0;
    opacity: 1 !important;
    position: absolute;
    height: 370px;
    width: 102%;
  }

  .center-text {
    text-align: center;
  }
  .start-text {
    text-align: start;
  }
  .left-text {
    text-align: left;
  }

  .button-end {
    position: absolute;
    bottom: 0;
    right: 0;
  }
  .button-end-l {
    position: absolute;
    bottom: 0;
    left: 0;
  }
  .v-window__next,
  .v-window__prev {
    background: none !important;
  }

  .bg-color-red {
    background-color: #10A087;
    height: 2px;
    margin-left: 20%;
    margin-right: 20%;
  }
  .primary---text {
    color: #10A087 !important;
  }
  .w-full{
    width: 100%;
  }
  .image-container {
    position: relative;
    border-radius: 500px;
    overflow: hidden;
    width: 40vw;
    height: 40vw;
  }
  .green-tint {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(52, 160, 141, 0.8); /* Adjust the rgba value to control the tint color and opacity */
    mix-blend-mode: multiply;
  }

  .hero-background {
    padding: 20px;
    background-image: url('../assets/backdrop-banner.jpg'); /* Replace with your image path */
    background-position: top;
    background-repeat: no-repeat;
    height: 73vh;
  }

  .hero-background {
    background-size: contain;
  }

  .orbit-container {
    position: relative;
    margin-left: 12%;
    height: 400px; /* Set desired height */
    width: 400px;
    /* background-color: #f5f5f5ef; */
  }

  .red-dot {
    width: 15px;
    height: 15px;
    background-color: red;
    border-radius: 50%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -180px); /* Adjust orbit radius */
    animation: orbit 60s steps(60) infinite;
  }

  .whitespace-nowrap {
    white-space: nowrap;
  }

  .red-dot-static {
    width: 25px;
    height: 25px;
    background-color: red;
    border-radius: 50%;
    position: absolute;
    top: 50%;
    left: 50%;
  }

  @keyframes orbit {
    0% {
      transform: rotate(0deg) translate(-50%, -180px) rotate(0deg);
    }
    100% {
      transform: rotate(360deg) translate(-50%, -180px) rotate(-360deg);
    }
  }

  @media (max-width: 960px) {
    .hero-background {
      background-size: cover;
    }

    .md-hidden {
      display: none;
    }
  }

  .logo-text {
    width: 205px;
  }

  @media (max-width: 450px) {
    .logo-text {
      width: 105px;
    }
  }

  .custom-list {
    list-style-type: upper-roman; /* Changes to Roman numerals */
  }

  .custom-list>li::marker {
    font-size: 1.5rem; /* Increases the size of just the numbers (supported in most modern browsers) */
    font-weight: bold; /* Makes the numbers bold */
  }

  .filled-disc ul{
    list-style-type: disc; /* Changes to disc */
  }
</style>
